export default __webpack_public_path__ + "static/media/2.2f261f12.png";